class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tab_selector = `data-product-tabs-content`;
    this.tab_containers = [...this.querySelectorAll(`[${this.tab_selector}]`)];
    this.button_selector = 'data-product-tabs-button';
    this.buttons = [...this.querySelectorAll(`[${this.button_selector}]`)];
    this.mobile_menu = this.querySelector('custom-dropdown');
    this.is_mobile = window.innerWidth < 990 ? true : false;
    this.clicked_index = '0';
    window.addEventListener('resize', () => {
      if (window.innerWidth > 990 && this.is_mobile) {
        this.buttons[0].click();
        this.is_mobile = false;
      } else if (window.innerWidth < 990 && !this.is_mobile) {
        this.buttons[0].click();
        this.is_mobile = true;
      }
    });
    this.init();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        const product_tabs = e.target.querySelector('product-tabs');
        if (product_tabs) product_tabs.init();
      });

      document.addEventListener('shopify:block:select', (e) => {
        const tab = document.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        if (tab) {
          const product_tabs = tab.closest('product-tabs');
          product_tabs.init();
          tab.click();
          this.mobile_menu._handleSetValueAndLabel({
            currentTarget: this.mobile_menu.querySelector(`[${this.button_selector}='${this.clicked_index}']`)
          });
        }
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        const product_tabs = e.target.querySelector('product-tabs');
        if (product_tabs) product_tabs.init();
      });
    }
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.buttons[0].click();
  }

  onButtonClick(event) {
    const button = event.target;
    this.clicked_index = button.dataset.productTabsButton;
    this.buttons.forEach((e, i) => {
      const button_index = e.dataset.productTabsButton;
      if (this.clicked_index == button_index) e.classList.add('active');
      else e.classList.remove('active');
    });
    this.tab_containers.forEach((e, i) => {
      const active_index = e.dataset.productTabsContent;
      if (this.clicked_index == active_index) e.classList.remove('hidden');
      else e.classList.add('hidden');
    });
  }
}

if (!customElements.get('product-tabs')) customElements.define('product-tabs', ProductTabs);
